/* eslint-disable radix */
const formatNumber = (value: number | string): string | number => {
  if (!Number.isInteger(value)) return value;

  return value.toLocaleString('pt-BR');
};

export const maskItem = (mask: string, value: any): any => {
  if (!value) return value;

  switch (mask) {
    case 'format_number':
      return formatNumber(parseInt(value));
    default:
      return value;
  }
};
